
export const moduleRoutes = {
    list: 'companies/',
    create: 'companies/',
    dashChart: 'companies/top-chart/',
    sync: 'companies/synchronize-tableau/',
    updateTableauLink: 'companies/update-tableau-links/',
};
